export default __webpack_public_path__ + "static/Gotham-BookItalic-a5c51b4217cf300462656604d984be05.woff2";